<template>
  <li
    class="row col-xs-6">
    <div class="col-xs-3 col-sm-2">
      <img :src="talent.profile_image_url" alt="">
    </div>
    <div class="col-xs-9 col-sm-6">
      <div class="details">
        <p>
          <strong>{{ talent.name }}</strong>
          <i v-if="talent.management && !$userIsManager" class="fa fa-fw fa-group" :aria-label="talent.management.company" :title="talent.management.company" ></i>
          <i v-if="talent.profile.visibility === 'hidden' && ($userIsAdmin || $userIsManager)" class="fa fa-eye-slash" aria-label="hidden" title="hidden"/>
          <i v-if="talent.profile.visibility === 'private' && ($userIsAdmin || $userIsManager)" class="fa fa-lock" aria-label="private" title="private"/>
        </p>
        <p>{{ talent.profile.tagline }}</p>
        <p v-if="talent.is_recommended" class="brand-primary">Recommended</p>
      </div>
    </div>
    <div class="col-xs-6 col-sm-2">
      <div v-if="!talentIsAlreadyAdded && talent.is_recommended">
        <a v-if="talentIsAlreadyRejected" @click="handleRemoveRejectedTalentCallback(talent)" class="btn btn-lg btn-danger"><i class="fa fa-fw fa-times"></i></a>
        <a v-else @click="handleRejectTalentCallback(talent)" class="btn btn-lg btn-default"><i class="fa fa-fw fa-minus"></i></a>
      </div>
    </div>
    <div class="col-xs-6 col-sm-2">
      <div v-if="!talentIsAlreadyRejected">
        <a v-if="talentIsAlreadyAdded" @click="handleRemoveTalentCallback(talent)" class="btn btn-lg btn-success"><i class="fa fa-fw fa-check"></i></a>
        <a v-else @click="handleAddTalentCallback(talent)" class="btn btn-lg btn-default"><i class="fa fa-fw fa-plus"></i></a>
      </div>
    </div>
  </li>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'

export default {
  props: {
    talent: {
      type: Object,
      required: true
    },
    talentIsAlreadyRejected: {
      type: Boolean,
      required: true
    },
    handleRemoveRejectedTalentCallback: {
      type: Function,
      required: true
    },
    handleRejectTalentCallback: {
      type: Function,
      required: true
    },
    handleAddTalentCallback: {
      type: Function,
      required: true
    },
    handleRemoveTalentCallback: {
      type: Function,
      required: true
    }
  },

  computed: {
    ...mapState('filtering', ['selectedStars']),

    talentIsAlreadyAdded () {
      return find(this.selectedStars, added => added.id === this.talent.id) !== undefined
    }
  }
}
</script>
